import React, { useState, useEffect } from 'react';
import {
    Row, Input, Button, Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Validation from '../../../../../../components/Validation';
function VideoLink({
    reloadBotResponse,
    caption,
    url,
    code,
    messages,
    urls,
    captions,
    details,
    index,
    setIsEditingToFalse,
    setIsAddVideoToFalse,
    isAddVideo,
    /** Globle property id from redux */
    propertyId,
    apiButtons,
    SaveRecommenderQuestionCode,
    locale,
    selectedLang,
    historyUpdator
}) {
    const [urlInput, setUrlInput] = useState(url || '');
    const [captionInput, setCaptionInput] = useState(caption || '');
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [postData, setPostData] = useState({
        GroupId: getGroupID(),
        Code: code,
        Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
        Channel: 'WebsiteDirectLine',
        PropertyId: propertyId === "-1" ? null : propertyId,
        Default: null,
        Overrides: {},
        UserName: historyUpdator
    });

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };

    const selectedImage = (link) => {
        setUrlInput(link.src)
        setCaptionInput(link.caption)
    };

    useEffect(() => {
        //console.log('details', details);
        console.log(urlInput, captionInput);
        let videoList = [];
        setPostData(pre => {
            if (!isAddVideo) {
                videoList = urls.map((url, index) => {
                    const videoCaption = captions[index];
                    return { Url: url, Caption: videoCaption };
                });
                videoList[index].Url = urlInput;
                videoList[index].Caption = captionInput;
            }

            if (isAddVideo) {
                let idx = urls.length - 1;
                videoList = urls.map((url, index) => {
                    const videoCaption = captions[index];
                    return { Url: url, Caption: videoCaption };
                });
                videoList[idx + 1] = { Url: '', Caption: '' };
                videoList[idx + 1].Url = urlInput;
                videoList[idx + 1].Caption = captionInput;
                // console.log('object', idx);
            }
            //console.log('imageList', imageList);
            return {
                ...pre,
                Default: {
                    Messages: messages,
                    Videos: videoList,
                    apiButtons: apiButtons
                },
            };
        });
        //console.log('Image Post Data', postData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlInput, captionInput]);

    const handleCaptionChange = e => {
        setCaptionInput(e.target.value);
    };

    const handleUrlChange = e => {
        setUrlInput(e.target.value);
    };

    const handleSave = async () => {
        try {
            return await AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Response}`,
                data: postData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        if (setIsEditingToFalse) {
                            setIsEditingToFalse();
                        }
                        if (setIsAddVideoToFalse) {
                            setIsAddVideoToFalse();
                        }
                        setTimeout(() => {
                            if (SaveRecommenderQuestionCode !== undefined) {
                                SaveRecommenderQuestionCode();
                            }
                            else {
                                reloadBotResponse();
                            }
                        }, 1000)
                    }
                })
                .finally(

            );
        } catch (error) {
            console.error(error);
        }
    };

    const handleCancel = () => {
        if (setIsEditingToFalse) {
            setIsEditingToFalse();
        }
        if (setIsAddVideoToFalse) {
            setIsAddVideoToFalse();
        }
    };
    return (
        <div>
            <Row>
                <Colxx xxs="4">Caption</Colxx>
                <Colxx xxs="8">
                    <Input
                        type="text"
                        value={captionInput}
                        onChange={handleCaptionChange}
                    ></Input>
                </Colxx>
            </Row>
            <Row>
                <Colxx xxs="4">Video Link</Colxx>
                <Colxx xxs="8">
                    <Input
                        type="text"
                        value={urlInput}
                        onChange={handleUrlChange}
                    ></Input>
                </Colxx>
            </Row>
            <Row>
                <Colxx xxs="4">
                </Colxx>
                <Colxx xxs="8">
                    <div
                        className="float-right"
                        style={{ marginTop: ' 5px', marginBottom: '5px' }}
                    >

                        <Button
                            color="secondary"
                            className="add-button"
                            size="xs"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                        <b> </b>
                        <Button
                            color="light"
                            className="add-button"
                            size="xs"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </Colxx>
            </Row>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps)(VideoLink));